<template>
  <div class="warehouse-form">
    <div class="card" style="max-width: 900px;">
      <form class="form-grid" @submit.prevent="transferItem">
        <div class="card-header">
          <div>
            <h2 class="title" style="font-size: 22px;">Transferir item</h2>
            <p class="subtitle">Selecione o item e o projeto de destino.</p>
          </div>
        </div>

        <div class="grid" style="grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 14px;">
          <div class="input-field">
            <label for="transfer-item">Item</label>
            <select id="transfer-item" v-model="form.itemId">
              <option value="">Selecione um item</option>
              <option v-for="item in items" :key="item.id" :value="item.id">
                {{ item.name }} ({{ item.code }})
              </option>
            </select>
          </div>

          <div class="input-field">
            <label for="transfer-project">Projeto de destino</label>
            <select id="transfer-project" v-model="form.projectId">
              <option value="">Sem area</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ project.name }}
              </option>
            </select>
          </div>
        </div>

        <p v-if="error" class="subtitle" style="color: #a54b2a;">{{ error }}</p>

        <div class="actions">
          <button class="btn btn-primary" type="submit" :disabled="saving">{{ saving ? 'Transferindo...' : 'Transferir' }}</button>
          <button class="btn btn-ghost" type="button" :disabled="saving" @click="goBack">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { projectsStore } from '@/store/projects'
import { warehouseStore } from '@/store/warehouse'

export default defineComponent({
  name: 'WarehouseTransferItemForm',
  setup() {
    const router = useRouter()
    const error = ref('')
    const saving = ref(false)
    const form = ref({
      itemId: '',
      projectId: ''
    })

    const items = computed(() => warehouseStore.all())
    const projects = computed(() => projectsStore.all())

    const transferItem = async () => {
      error.value = ''
      if (!form.value.itemId) {
        error.value = 'Selecione o item que sera transferido.'
        return
      }
      const item = warehouseStore.all().find((entry) => entry.id === form.value.itemId)
      if (!item) {
        error.value = 'Item nao encontrado.'
        return
      }
      saving.value = true
      try {
        await warehouseStore.upsert({
          id: item.id,
          code: item.code,
          name: item.name,
          category: item.category,
          quantityTotal: item.quantityTotal,
          quantityMin: item.quantityMin,
          location: form.value.projectId,
          conditionStatus: item.conditionStatus,
          unitValue: item.unitValue,
          photoDataUrl: item.photoDataUrl
        })
        await router.push('/almoxarifado?tab=estoque')
      } finally {
        saving.value = false
      }
    }

    const goBack = () => {
      router.push('/almoxarifado?tab=estoque')
    }

    onMounted(() => {
      Promise.all([warehouseStore.refresh(), projectsStore.refresh()]).catch(() => {
        error.value = 'Nao foi possivel carregar dados para transferencia.'
      })
    })

    return {
      form,
      items,
      projects,
      error,
      saving,
      transferItem,
      goBack
    }
  }
})
</script>

<style scoped lang="scss">
.warehouse-form {
  width: 100%;
}
</style>
